// dependencies
import React from "react";

// styles
import css from "./BambooHRButton.module.scss";

type BambooHRButtonProps = {
	email: string;
	companyID?: string;
};

const BambooHRButton = ({ email, companyID }: BambooHRButtonProps) => (
	<form method="POST" action="/login/bamboohr-subdomain/">
		<input type="hidden" name="email" value={email} />
		{companyID ? <input type="hidden" name="companyID" value={companyID} /> : null}
		<button type="submit" className={`${css.main}`} aria-label="Sign in with BambooHR">
			<div className={css.iconWrapper}>
				<img alt="" src="https://talent.performyard.com/static/img/Integrations/bamboohr-circle-icon.png" />
			</div>
			<div className={css.label}>Sign in with BambooHR</div>
		</button>
	</form>
);

export default BambooHRButton;
